<div class="grid-6 copo-container footer-margin" *ngIf="segment && segment.anisotropyList && this.segment.anisotropyList.length > 0">
	<div class="grid-column-one-full">
		<mat-expansion-panel [expanded]="true" class="card-info-block">
			<mat-expansion-panel-header>
				<mat-panel-title class="card-content-title">
					<span translate>aqdb.mechanical.characteristics.anisotropy</span>
				</mat-panel-title>
			</mat-expansion-panel-header>
			<mat-divider class="margin-expansion-panel"></mat-divider>
			<div class="card-content-block triple-column" *ngFor="let anisotropy of segment.anisotropyList">
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.test.number.anisotropy</div>
						<div class="card-content-value">{{ anisotropy.testNumber !== null && anisotropy.testNumber !== undefined ? (anisotropy.testNumber | copoNumber:'number') : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.anisotropy.direction</div>
						<div class="card-content-value"> 
							<div *ngIf="anisotropy.sampleDirectionCode === 'T'">
								<span translate>aqdb.direction.T</span>
							</div>
							<div *ngIf="anisotropy.sampleDirectionCode === 'L'">
								<span translate>aqdb.direction.L</span>
							</div>
							<div *ngIf="anisotropy.sampleDirectionCode !== 'T' && anisotropy.sampleDirectionCode !== 'L'">
								{{ UNDERSCORE }}
							</div>
						</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.anisotropy.r</div>
						<div class="card-content-value">{{ anisotropy.anisotropyCoefficient && isDisplayedData(anisotropy.indTrsR) ? (anisotropy.anisotropyCoefficient | copoNumber:'weight') : UNDERSCORE }}
							<span *ngIf="isTransmittedOnCertificateData(anisotropy.indTrsR)" class="transmitted-data-icon"><mat-icon [matTooltip]="'aqdb.datas.transmitted.on.certificate' | translate" color="accent" class="batch-icon" svgIcon="icon-transmitted"></mat-icon></span>
							<span *ngIf="isMeasuredData(anisotropy.indTrsR, anisotropy.anisotropyCoefficientTypdon)"><mat-icon [matTooltip]="'aqdb.measured.datas' | translate" color="accent" class="batch-icon" svgIcon="icon-measured"></mat-icon></span>
							<span *ngIf="isModelledData(anisotropy.indTrsR, anisotropy.anisotropyCoefficientTypdon)"><mat-icon  [matTooltip]="'aqdb.modelled.data' | translate" color="accent" class="batch-icon" svgIcon="icon-modelled"></mat-icon></span>
						</div>
					</div>
				</div>
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.pos.across.width</div>
						<div class="card-content-value"> 
							<div *ngIf="anisotropy.samplePositionAcrossWidthCode === 'A'">
								<span translate>aqdb.axis</span>
							</div>
							<div *ngIf="anisotropy.samplePositionAcrossWidthCode === 'Q'">
								<span translate>aqdb.quarter</span>
							</div>
							<div *ngIf="anisotropy.samplePositionAcrossWidthCode !== 'A' && anisotropy.samplePositionAcrossWidthCode !== 'Q'">
								{{ UNDERSCORE }}
							</div>
						</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.pos.across.length</div>
						<div class="card-content-value">{{ anisotropy.samplePositionAlongLength !== null && anisotropy.samplePositionAlongLength !== undefined ? (anisotropy.samplePositionAlongLength | copoNumber:'weight') : UNDERSCORE }} </div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.test.steel.condition</div>
						<div class="card-content-value">{{ anisotropy.testSteelCondition ? anisotropy.testSteelCondition : UNDERSCORE }}</div>
					</div>
				</div>
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.anisotropy.avg.r</div>
						<div class="card-content-value">{{ anisotropy.averageAnisotropyCoefficient && isDisplayedData(anisotropy.indTrsAverageR) ? (anisotropy.averageAnisotropyCoefficient | copoNumber:'weight') : UNDERSCORE }}
							<span *ngIf="isTransmittedOnCertificateData(anisotropy.indTrsAverageR)" class="transmitted-data-icon"><mat-icon [matTooltip]="'aqdb.datas.transmitted.on.certificate' | translate" color="accent" class="batch-icon" svgIcon="icon-transmitted"></mat-icon></span>
							<span *ngIf="isMeasuredData(anisotropy.indTrsAverageR, anisotropy.averageAnisotropyCoefficientTypdon)"><mat-icon [matTooltip]="'aqdb.measured.datas' | translate" color="accent" class="batch-icon" svgIcon="icon-measured"></mat-icon></span>
							<span *ngIf="isModelledData(anisotropy.indTrsAverageR, anisotropy.averageAnisotropyCoefficientTypdon)"><mat-icon  [matTooltip]="'aqdb.modelled.data' | translate" color="accent" class="batch-icon" svgIcon="icon-modelled"></mat-icon></span>
						</div>
					</div>
				</div>
			</div>
		</mat-expansion-panel>
	</div>
</div>
